module.exports = __webpack_public_path__ + "static/img/img.c7028307.png";